const pageNames = Object.freeze({
  // <---- Channel Steering Page Group ---->
  contactUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::contact-us:::',
  },
  contactUsChatTimeoutPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chat-timeout:::',
  },
  callUsPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::callus:::',
  },
  // Call Us redesign page
  callPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::call:::',
  },
  emailPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::email:::',
  },
  emailByPassPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass:::',
  },
  intermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::intermediate:::',
  },
  chatBot: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot:::',
  },
  webPinNotApplicable: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-not-applicable:::',
  },
  // RAC
  requestACall: {
    // RAC inside call us
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACall:::',
  },
  requestACallError: {
    // RAC submit failed due to a reason
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACallError:::',
  },
  requestACallSuccess: {
    // RAC successfully submitted
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::requestACallSuccess:::',
  },

  // webPin Impression tracking
  webPinSuccess: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin:::',
  },

  webPinfailure: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::web-pin-error:::',
  },

  // <---- Error Pages ---->
  ErrorPage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::error:::',
  },
  emailByPassPageError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::emailByPass-error:::',
  },
  chatBotArticleInEligible: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::smart-chatBotInEligible:::',
  },
  chatBotArticleError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  chatBotContactUsError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  chatBotHomeError: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot-did-not-load-error:::',
  },
  contactLexaFailureError: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },
  articleLexaFailureError: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::lexa-failure-intermediate:::',
  },

  // <---- HCR Page Group ---->
  homePage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::home:::',
  },
  PCCTrackingPage: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::pcc:::',
  },
  searchPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search:::',
  },
  searchErrorPage: {
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::search-error:::',
  },
  articlePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article:::',
  },
  articleErrorPage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::article-error:::',
  },
  topicPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic:::',
  },
  chatBotHome: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::chatBot:::',
  },
  chatBotArticle: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::chatBot:::',
  },
  topicErrorPage: {
    pageGroupName: 'main:help:smart::topic',
    pageName: 'main:help:smart::topic-error:::',
  },
  articleintermediatePage: {
    pageGroupName: 'main:help:smart::article',
    pageName: 'main:help:smart::intermediate:::',
  },
  // <!-- Step-up -->
  stepUpIntermediatePage: {
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::step-up-intermediate:::',
  },
  confirmAuthPrompt: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-prompt:::',
  },
  confirmAuthFailure: {
    pageGroupName: 'main:help:smart::home',
    pageName: 'main:help:smart::confirm-auth-failure:::',
  },

  // Dispute-Info
  disputeContactInfo: { // Dispute alert default tracking
    pageGroupName: 'main:help:smart::contact-us',
    pageName: 'main:help:smart::dispute-status-info:::',
  },

  disputeSearchInfo: { // Dispute alert default tracking
    pageGroupName: 'main:help:smart::search',
    pageName: 'main:help:smart::dispute-status-info:::',
  },

  disputeTransactions: {
    pageGroupName: 'main:help:smart::transactions',
    pageName: 'main:help:smart::dispute-transactions:::',
  },
});

const PageMapping = {
  'contact-us': 'contactUsPage',
  callus: 'callUsPage',
  email: 'emailPage',
  home: 'homePage',
  search: 'searchPage',
  article: 'articlePage',
  topic: 'topicPage',
};

module.exports = {
  pageNames,
  PageMapping,
};
